import React, { useState } from 'react';
import userService from '../../user.service';
import { refresh, logout } from '../../utils/index';
import NewUserInfo from '../../Main/NewUserInfo';
import { Dialog, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from '../../Main/main.styles';
import axios from 'axios';
import { isEmpty, map } from 'lodash';
import moment from 'moment';
import Calender from '../Dashboard/components/Calender';
import AddEvents from '../Dashboard/components/AddEvents';
import TodayEventsList from '../Dashboard/components/TodayEventsList';
import EmergencyButton from '../Components/EmergencyButton';
import useStore from '../../Store/Store';
import CircularProgress from '@mui/material/CircularProgress';
import RecipientsSelector from '../Components/RecipientsSelector';
import SideBar from '../../components/SideBar';

const useStyles = makeStyles()(styles);

const Caregivers = () => {
  let tab = '1';
  const history = useNavigate();
  const user = useStore((state) => state.user);
  const width = useStore((state) => state.screenWidth);
  const selectedRecipient = useStore((state) => state.selectedRecipient);

  const { classes } = useStyles();
  const [openAddEvents, setOpenAddEvents] = useState(false);
  const [showTodayEvent, setTodayEvents] = useState(false);
  const [calenderEvents, setCalenderEvents] = useState([]);
  const [caregivers, setCaregivers] = useState([]);
  const [eventLoader, setEventLoader] = useState(false);

  const location = useLocation();

  const query = new URLSearchParams(location.search);

  React.useEffect(() => {
    if (query.get('addEvent') === '1') {
      setOpenAddEvents(true);
    }
  }, [query]);

  const getEvents = React.useCallback(async () => {
    setEventLoader(true);
    try {
      let response = null;
      if (isEmpty(selectedRecipient)) {
        response = await axios.get(process.env.REACT_APP_EXPRESS_URL + `/api/canCare/user/${user?._id}/event`, {
          headers: {
            'Content-Type': 'application/json',
            authorization: localStorage.getItem('auth'),
          },
        });
      } else {
        response = await axios.get(
          process.env.REACT_APP_EXPRESS_URL + `/api/canCare/caregiver/${user?._id}/userEvents/${selectedRecipient}`,
          {
            headers: {
              'Content-Type': 'application/json',
              authorization: localStorage.getItem('auth'),
            },
          },
        );
      }
      const events = map(response?.data?.data || [], (item) => ({
        ...item,
        title: item?.title,
        start: moment.unix(item?.start).add(moment().utcOffset(), 'minutes').toDate(),
        end: moment.unix(item?.end).add(moment().utcOffset(), 'minutes').toDate(),
      }));
      setCalenderEvents(events);
    } catch (error) {
      console.log(error);
    } finally {
      setEventLoader(false);
    }
  }, [user, selectedRecipient]);

  React.useEffect(() => {
    if (user) {
      getEvents();
    }
  }, [selectedRecipient]);

  const closeEventModel = () => {
    query.delete('addEvent');
    history({ search: query.toString() });
    setOpenAddEvents(false);
  };

  const getUserCaregivers = React.useCallback(async () => {
    try {
      if (!isEmpty(selectedRecipient)) {
        const { data } = await axios.get(
          process.env.REACT_APP_EXPRESS_URL + `/api/canCare/caregiver/${user?._id}/userCaregivers/${selectedRecipient}`,
          {
            headers: {
              'Content-Type': 'application/json',
              authorization: localStorage.getItem('auth'),
            },
          },
        );
        const users = map(data?.data, ({ caregiverId }) => ({
          userId: caregiverId?._id,
          name: `${caregiverId?.userInfo?.firstName} ${caregiverId?.userInfo?.lastName || ''}`,
          email: caregiverId?.email,
          username: caregiverId?.username,
        }));
        setCaregivers(users);
      } else {
        const { data } = await axios.get(
          process.env.REACT_APP_EXPRESS_URL + `/api/canCare/user/${user?._id}/getCaregivers`,
          {
            headers: {
              'Content-Type': 'application/json',
              authorization: localStorage.getItem('auth'),
            },
          },
        );
        const users = map(data?.data, ({ caregiverId }) => ({
          userId: caregiverId?._id,
          name: `${caregiverId?.userInfo?.firstName} ${caregiverId?.userInfo?.lastName || ''}`,
          email: caregiverId?.email,
          username: caregiverId?.username,
        }));
        setCaregivers(users);
      }
    } catch (error) {
      console.log(error);
    }
  }, [selectedRecipient]);

  React.useEffect(() => {
    getUserCaregivers();
  }, [selectedRecipient]);

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
        <div>
          <SideBar />
        </div>

        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <NewUserInfo isSideBar={false} />
          <div style={{ padding: '20px', width: '100%' }}>
            {eventLoader && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '40vh',
                  width: '100%',
                }}
              >
                <CircularProgress style={{ color: '#26786a' }} size={100} />
              </div>
            )}
            {!eventLoader && (
              <Grid
                container
                item
                direction="row"
                justify="flex-start"
                className={classes.deviceList}
                xs={11}
                sm={11}
                md={11}
                lg={11}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginBottom: '40px',
                  marginTop: '0px',
                }}
              >
                <RecipientsSelector />
                <Calender
                  events={calenderEvents}
                  handleAddEvent={() => setOpenAddEvents(true)}
                  showTodaysEvent={() => setTodayEvents(true)}
                  isDay={false}
                />
              </Grid>
            )}
          </div>
        </div>
      </div>
      <Dialog className={classes.modal} open={openAddEvents} maxWidth={false}>
        <AddEvents
          closeModal={closeEventModel}
          user={user}
          refreshEvents={getEvents}
          caregivers={caregivers}
          selectedRecipient={selectedRecipient}
        />
      </Dialog>
      <Dialog className={classes.modal} open={showTodayEvent} fullWidth={true}>
        <TodayEventsList closeModal={() => setTodayEvents(false)} user={user} tab={tab} />
      </Dialog>
      <EmergencyButton />
    </>
  );
};

export default Caregivers;
